import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getNotes(contactId, page) {
        return Axios.get(`${baseURL}actor/contact-notes/${contactId}`, {
            params: { type: "remark", page }
        }).then(response => response.data.response);
    },
    reorderNotes(params) {
        return Axios.post(`${baseURL}actor/contact-notes/reorder`, params).then(
            response => response.data.response
        );
    },
    getPopupNotes(contactId) {
        return Axios.get(
            `${baseURL}actor/contact-notes/popup/${contactId}`
        ).then(response => response.data.response);
    },
    editNote(noteId, params) {
        return Axios.put(
            `${baseURL}actor/contact-notes/${noteId}`,
            params
        ).then(response => response.data.response);
    },
    deleteNote(noteId) {
        return Axios.delete(`${baseURL}actor/contact-notes/${noteId}`).then(
            response => response.data.response
        );
    },
    addNote(params) {
        return Axios.post(`${baseURL}actor/contact-notes`, params).then(
            response => response.data.response
        );
    }
};
